<template>
    <v-container fluid>
        <v-row>
            <v-col cols="12" class="pa-3">
               <deposito-crud />
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
    import DepositoCrud from "./DepositoCrud";
    export default {
        name: "Deposito",
        components: {DepositoCrud}
    }
</script>

<style scoped>

</style>

